import React, { useState } from "react";
import "../../assets/css/privacy_consent_modal.scss";

const GeulpicConsentModal = ({ isOpen, onClose, onNext }) => {
  const [isAgreed, setIsAgreed] = useState(false);

  if (!isOpen) return null;

  const handleNext = () => {
    if (!isAgreed) {
      alert("개인정보 수집 및 이용에 동의해주세요.");
      return;
    }
    onNext();
  };

  const handleClose = () => {
    setIsAgreed(false);
    onClose();
  };

  return (
    <div className="privacy-modal-overlay" onClick={handleClose}>
      <div
        className="privacy-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="privacy-modal-header">
          <h2 className="privacy-modal-title">글픽</h2>
          <button className="privacy-modal-close" onClick={handleClose}>
            ✕
          </button>
        </div>

        <div className="privacy-modal-body">
          <h3 className="privacy-section-title">
            글픽 개인정보 수집 및 이용약관
          </h3>

          <div className="privacy-content-box">
            <p>
              (주)동아이지에듀는 다음과 같은 원칙에 의하여 회원의 개인정보를
              수집, 이용 및 관리하고 있고, 이와 관련하여 정보통신서비스 제공자가
              준수해야 하는 대한민국의 관계법령 및 개인정보보호 규정,
              가이드라인을 준수하고 있습니다. 회사는 개인정보 처리방침을 통하여,
              회원의 개인정보가 어떠한 용도와 방식으로 이용되고 있으며,
              개인정보보호를 위해 회사가 어떠한 조치를 취하는지 알려드립니다.
            </p>

            <p>
              동아이지에듀의 개인정보 처리방침은 다음과 같은 내용을 담고
              있습니다.
            </p>
            <p>1. 개인정보의 수집</p>
            <p>2. 수집한 개인정보 이용</p>
            <p>3. 개인정보 제공 및 위탁</p>
            <p>4. 개인정보 파기</p>
            <p>5. 개인정보관리 책임자 및 담당자</p>
            <p>6. 회원의 권리와 그 행사방법</p>
            <p>7. 개인정보 안전성 확보조치</p>
            <p>8. 고지 의무</p>

            <h4>1. 개인정보의 수집</h4>
            <p>
              <strong>① 개인정보 수집 원칙</strong>
              <br />
              가. 동아이지에듀는 서비스 제공에 필요한 최소한의 개인정보만
              수집하도록 필수항목과 선택항목으로 구분하여 수집하며, 수집 시
              반드시 사전에 이용자의 동의를 구하도록 하고 있습니다.
            </p>

            <p>
              <strong>※ 필수항목과 선택항목</strong>
              <br />
              - 필수항목: 서비스의 본질적 기능을 수행하기 위해 필요한 정보
              <br />- 선택항목: 부가 가치를 제공하기 위해 추가로 수집하는
              정보로써, 입력하지 않아도 서비스 이용의 제한이 없는 정보
            </p>

            <p>
              나. 동아이지에듀는 법령에 따른 개인정보 보유, 이용기간 또는
              이용자로부터 개인정보를 수집 시에 동의 받은 개인정보 보유,
              이용기간 내에서 개인정보를 처리, 보유합니다.
            </p>

            <p>
              다. 정보통신망법 제31조(법정대리인의 권리)에 따라 만 14세 미만
              아동의 개인정보 수집 시 법정대리인의 정보를 수집하고 동의를 받고
              있습니다.
            </p>

            <p>
              라. 동아이지에듀는 회원의 사상, 신념, 과거의 병력 등 개인의 권리,
              이익이나 사생활을 뚜렷하게 침해할 우려가 있는 민감한 정보는
              수집하지 않습니다.
            </p>

            <p>
              <strong>② 개인정보 수집 방법</strong>
              <br />
              동아이지에듀는 홈페이지, 전화, 이벤트응모, 배송 요청 등의 방법으로
              이용자의 개인정보를 수집합니다.
            </p>

            <p>
              <strong>③ 개인정보 수집 목적 및 항목</strong>
            </p>

            <h4>2. 수집한 개인정보 이용</h4>
            <p>
              동아이지에듀는 다음 목적을 위하여 개인정보를 처리합니다. 처리하고
              있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용
              목적이 변경되는 경우에는 사전에 동의를 받는 등 필요한 조치를
              이행할 예정입니다.
            </p>

            <h4>3. 개인정보의 제공 및 위탁</h4>
            <p>
              <strong>① 개인정보의 제3자 제공</strong>
              <br />
              가. 동아이지에듀는 원칙적으로 이용자의 개인정보를 상기 명시한 범위
              내에서만 처리하며, 본래의 범위를 초과하여 처리하거나 제3자에게
              제공하지 않습니다.
            </p>

            <p>
              나. 더 나은 서비스 제공을 위하여 개인정보를 제3자에게 제공하거나
              공유하게 되는 경우에는 제공받는 자, 제공하는 개인정보 항목,
              제공받는 자의 개인정보 이용목적, 제공받는 자의 보유, 이용기간을
              명시하고 사전에 동의를 구하는 절차를 거치도록 하며, 동의하지 않는
              경우에는 제3자에게 제공 및 공유하지 않습니다.
            </p>

            <p>
              다. 단, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는
              경우에는 개인정보를 제3자에게 제공합니다.
            </p>

            <p>
              <strong>② 개인정보처리의 위탁</strong>
            </p>

            <h4>4. 개인정보 파기</h4>
            <p>
              동아이지에듀는 원칙적으로 개인정보 수집 및 이용목적이 달성된
              후에는 해당 정보를 지체 없이 파기합니다. 파기절차 및 방법은 다음과
              같습니다.
            </p>

            <p>
              <strong>① 파기 및 분리보관 절차</strong>
              <br />
              가. 회원이 회원가입 등을 위해 입력한 정보는 목적이 달성된 후
              별도의 DB 또는 테이블로 옮겨져 분리 보관되며 (종이의 경우 별도의
              서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에
              따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.
            </p>

            <p>
              나. 별도 DB 또는 테이블로 옮겨진 개인정보는 법률에 의한 경우가
              아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.
            </p>

            <p>
              <strong>② 파기 방법</strong>
              <br />
              가. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여
              파기합니다.
              <br />
              나. 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는
              기술적 방법을 사용하여 삭제합니다.
            </p>

            <h4>5. 개인정보관리 책임자 및 담당자</h4>
            <p>
              <strong>① 개인정보관리 책임자 및 담당부서</strong>
              <br />
              동아이지에듀는 이용자의 개인정보 처리에 관한 업무를 총괄해서
              책임지고, 이용자의 궁금증 해결, 불만처리를 위해 개인정보
              보호책임자 지정하여 운영하고 있습니다.
            </p>

            <p>
              <strong>개인정보관리 책임자 및 담당자</strong>
              <br />
              1. 성명(직위) : 김혜원
              <br />
              2. 전화번호 : 02-362-5110
              <br />
              3. 전자우편 : buster@donga.com
              <br />
              4. 소속부서 : 사업기획본부
            </p>

            <p>
              <strong>② 권익침해 구제방법</strong>
              <br />
              가. 개인정보 침해에 대한 피해구제, 신고, 상담이 필요하신 경우에는
              아래 기관에 문의하셔서 도움을 받을 수 있습니다.
              <br />
              나. 아래 기관은 동아이지에듀와는 별개의 기관입니다.
            </p>

            <h4>6. 회원의 권리와 그 행사방법</h4>
            <p>동아이지에듀는 회원의 권리를 다음과 같이 보호하고 있습니다.</p>
            <p>① 언제든지 자신의 개인정보를 조회하고 수정할 수 있습니다.</p>
            <p>
              ② 언제든지 개인정보 제공에 관한 동의 철회(구독해지)를 요청할 수
              있습니다.
            </p>
            <p>
              ③ 정확한 개인정보의 이용 및 제공을 위해 회원이 개인정보 수정 진행
              시 수정이 완료될 때까지 회원의 개인정보는 이용되거나 제공되지
              않습니다. 이미 제 3자에게 제공된 경우에는 지체 없이 제공받은
              자에게 사실을 알려 수정이 이루어질 수 있도록 하겠습니다.
            </p>
            <p>
              ④ 권리 행사는 회원 뿐만 아니라 위임을 받은 자 등 대리인을 통하여
              하실 수 있습니다. 이 경우 회사에서 요구하는 부가서류(본인확인
              증빙자료 및 위임장 등)를 제출하여야 합니다.
            </p>

            <h4>7. 개인정보 안전성 확보조치</h4>
            <p>
              동아이지에듀는 이용자의 개인정보를 소중히 여기며, 개인정보를
              처리함에 있어서 다음과 같은 노력을 다하고 있습니다.
            </p>

            <p>
              <strong>① 내부관리계획의 수립</strong>
              <br />
              개인정보의 안전한 처리를 위한 기준으로 내부관리계획을 수립 및
              시행하고 있습니다.
            </p>

            <p>
              <strong>② 개인정보 취급자 최소화</strong>
              <br />
              개인정보를 처리하는 직원을 최소화 하며, 개인정보를 처리하는
              데이터베이스와 개인정보처리시스템에 대한 접근 통제 기준을
              체계적으로 마련하고 지속적인 감사를 시행하고 있습니다.
            </p>

            <p>
              <strong>③ 정기 교육</strong>
              <br />
              개인정보 취급자들을 대상으로 정기 교육을 실시하고, 전사 직원을
              대상으로 개인정보 이슈 사항을 전파하여 개인정보의 중요성을
              강조하고 있습니다.
            </p>

            <p>
              <strong>④ 해킹이나 바이러스로부터 보호</strong>
              <br />
              시스템은 외부로부터 접근이 통제된 구역에 설치하여 개인정보의
              유출이나 훼손으로부터 보호합니다. 또한, 개인정보 훼손에 대비하여
              정기적 백업을 수행하고 백신프로그램을 이용하여 자료의 유출 및
              손상을 방지하고 있습니다.
            </p>

            <p>
              <strong>⑤ 개인정보의 암호화</strong>
              <br />
              이용자의 개인정보 전송 시 암호화된 통신구간을 이용하고, 비밀번호
              등 중요정보는 안전한 암호화 알고리즘을 사용하여 암호화 합니다.
            </p>

            <h4>8. 고지 의무</h4>
            <p>
              법령·정책 또는 보안기술의 변경에 따라 현 개인정보처리방침 내용의
              추가·삭제 및 수정이 있을 시에는 개정안 적용일의 7일 전부터 회사의
              홈페이지 내 고지합니다.
            </p>
            <p>
              다만, 개인정보의 수집 및 활용, 제 3자 제공 등과 같이 회원 권리의
              중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.
            </p>

            <p>
              - 개인정보 처리방침 공고일자: 2021년 03월 04일
              <br />- 개인정보 처리방침 시행일자: 2021년 03월 11일
            </p>
          </div>

          <div className="privacy-agreement">
            <label className="privacy-checkbox-label">
              <input
                type="checkbox"
                checked={isAgreed}
                onChange={(e) => setIsAgreed(e.target.checked)}
              />
              <span className="privacy-checkbox-text">
                (필수) 위의 "개인정보 수집 및 이용"에 동의합니다.
              </span>
            </label>
          </div>
        </div>

        <div className="privacy-modal-footer">
          <button className="privacy-next-button" onClick={handleNext}>
            다음
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeulpicConsentModal;
